import { WebPortalService } from "../resource";

const AuthModule = {
  namespaced: true,
  state: {
    data: [],
    user: {
      id: "",
      username: "",
      name: "",
      email: "",
      group: "",
      corporate: "",
      corporate_name: ""
    },
    locale: "th"
  },
  mutations: {
    SET_LOCALE(state, data) {
      state.locale = data;
    },
    SET_DATA(state, data) {
      state.data = data;
    },
    SET_USER(state, data) {
      state.user.id = data.Id;
      state.user.username = data.Username;
      state.user.name = data.Name;
      state.user.email = data.Email;
      state.user.group = data.GroupId;
      state.user.corporate = data.EnterpriseId;
      state.user.corporate_name = data.EnterpriseName;
    },
    CLEAR_USER(state, data) {
      state.user.id = "";
      state.user.username = "";
      state.user.name = "";
      state.user.email = "";
      state.user.group = "";
      state.user.corporate = "";
      state.user.corporate_name = "";
    }
  },
  actions: {
    ForgotPassword({ commit, state }, data) {
      return WebPortalService.ForgotPassword(data);
    },
    ResetPassword({ commit, state }, data) {
      return WebPortalService.ResetPassword(data);
    },
    setUser({ commit, state }, data) {
      commit("SET_USER", data);
    },
    getProfile({ commit, state }, data) {
      return WebPortalService.GetProfile(data);
    },
    createData({ commit, state }, data) {
      return WebPortalService.AuthCreate(data);
    },
    updateData({ commit, state }, data) {
      return WebPortalService.AuthUpdate(data);
    },
    deleteData({ commit, state }, data) {
      return WebPortalService.AuthDelete(data);
    },
    changeProfile({ commit, state }, data) {
      return WebPortalService.ChangeProfile(data);
    },
    changePassword({ commit, state }, data) {
      return WebPortalService.ChangePassword(data);
    },
    SignIn({ commit, state }, data) {
      return WebPortalService.SignIn(data);
    },
    async listData({ commit, state }) {
      try {
        const data = await WebPortalService.AuthList();
        if (data.data.Data == null) {
          commit("SET_DATA", []);
        } else {
          commit("SET_DATA", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATA", []);
      }
    },
    async signOut({ commit, state }) {
      try {
        const data = await WebPortalService.SignOut();
        commit("CLEAR_USER", state.user);
      } catch (err) {
        commit("CLEAR_USER", state.user);
      }
    },
    setLocale({ commit, state }, locale) {
      commit("SET_LOCALE", locale);
    }
  },
  getters: {
    getData(state) {
      return state.data;
    },
    getLocale(state) {
      return state.locale;
    },
    getUser(state) {
      return state.user;
    },
    isCorporateSuperAdmin(state) {
      return state.user.group == 4;
    },
    isDtacAdmin(state) {
      return state.user.group == 3;
    },
    isCorporateAdmin(state) {
      return state.user.group == 2;
    },
    isReadOnly(state) {
      return state.user.group == 1 || state.user.group == 3;
    },

    isCorporateSuperAdminMenu(state) {
      return state.user.group == 4;
    },
    isDtacAdminMenu(state) {
      return state.user.group == 3;
    },
    isCorporateAdminMenu(state) {
      return state.user.group == 2 || state.user.group == 4;
    },
    isReadOnlyMenu(state) {
      return state.user.group == 1;
    },

    isAuthenticate(state) {
      return state.user.id != "";
    }
  }
};

export default AuthModule;
